import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	background: ${palette('gradientCalmBrand')};
	color: ${palette('white')};
	overflow: hidden;
	position: relative;
	text-align: center;

	${minWidth('desktop')} {
		text-align: left;
	}
`;

export const Content = styled.div`
	grid-column: 1 / 5;
	padding: 40px 0;

	${minWidth('desktop')} {
		grid-column: 1 / 3;
		padding: 136px 0 40px;
	}
`;

export const Heading = styled.h1`
	font-size: 28px;
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 16px;

	${minWidth('tablet')} {
		${fontWeight(FontWeights.Regular)};
		font-size: 49.5px;
	}
`;

export const Subheading = styled.h3`
	font-size: 20px;
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const ButtonWrapper = styled.div`
	margin: 0 auto 48px;
	max-width: 328px;
	width: 100%;

	${minWidth('mobileLarge')} {
		width: 50%;
	}

	${minWidth('desktop')} {
		margin: 0 0 48px;
		width: 75%;
	}
`;

export const DeviceImageWrapper = styled.div`
	grid-column: 1 / 5;
	height: auto;
	margin: 0 auto;
	width: 80%;

	${minWidth('desktop')} {
		grid-column: 3 / 5;
		margin-top: auto;
		width: 100%;
	}
`;
